import { getClientCompanyById } from '@/api/company';
import { useApiQuery } from '@/hooks/api';
import { LISTING_STALE_TIME } from '@/hooks/api/defaults';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { ClientCompanyDetail } from '@/types/company';

export function useClientCompany(
  companyId: string | null | undefined,
  options?: { enabled?: boolean },
) {
  return useApiQuery<ClientCompanyDetail | null>({
    queryKey: queryKeys.company.byId(companyId ?? ''),
    queryFn: async () => {
      if (!companyId) return null;
      const res = await getClientCompanyById(companyId);
      return res ?? null;
    },
    enabled: Boolean(companyId) && (options?.enabled ?? true),
    staleTime: LISTING_STALE_TIME,
  });
}
